import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { aboutInfo, faqData } from '@/mocks/articles';

export default function AboutPage() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '黑料718',
        url: 'http://gjxfl.cn/',
        description: '国内领先的娱乐资讯聚合平台',
        slogan: '全网吃瓜，只在718',
        contactPoint: {
          '@type': 'ContactPoint',
          email: aboutInfo.contact.email,
          contactType: 'customer service',
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: '上海',
          addressRegion: '浦东新区',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 黑料718',
        url: 'http://gjxfl.cn/about',
        description: '了解黑料718的品牌故事、核心价值与联系方式。全网吃瓜，只在718。',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://gjxfl.cn/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://gjxfl.cn/about' },
          ],
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqData.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <title>关于黑料718 | 品牌介绍与联系方式 | 黑料718官网</title>
      <meta name="description" content="了解黑料718的品牌故事与发展历程。黑料718是国内领先的娱乐资讯聚合平台，主打网红塌房、明星聊天记录泄露和博主反差视频等爆料内容。获取最新地址、APP下载与联系方式。" />
      <meta name="keywords" content="黑料718, 黑料718官网, 关于黑料718, 黑料718最新地址, 黑料718下载, 718黑料" />
      <link rel="canonical" href="http://gjxfl.cn/about" />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="relative pt-24 pb-16 bg-background-100">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
              <nav className="flex items-center space-x-2 text-sm text-foreground-500 mb-8" aria-label="Breadcrumb">
                <Link to="/" className="hover:text-primary-400 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
                <span className="text-foreground-300">关于我们</span>
              </nav>

              <div className="max-w-3xl">
                <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-50 leading-tight mb-4">
                  全网吃瓜
                  <br />
                  只在<strong className="text-primary-400">黑料718</strong>
                </h1>
                <p className="text-foreground-400 text-base leading-relaxed max-w-xl">
                  国内领先的娱乐资讯聚合平台，专注为吃瓜群众提供最新、最全、最真实的爆料内容。
                </p>
              </div>
            </div>
          </section>

          <section className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <span className="inline-block px-3 py-1 bg-primary-500/10 border border-primary-500/20 rounded-full text-primary-400 text-xs font-medium mb-4">
                  关于黑料718
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-50 mb-6">
                  品牌<strong className="text-primary-400">介绍</strong>
                </h2>
                <div className="space-y-4 text-foreground-400 text-sm leading-relaxed">
                  <p>{aboutInfo.introduction}</p>
                  <p>{aboutInfo.mission}</p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
                  {aboutInfo.stats.map((stat) => (
                    <div key={stat.label} className="bg-background-100 rounded-xl p-4 text-center border border-background-200/60">
                      <p className="text-primary-400 text-2xl font-black font-heading">{stat.value}</p>
                      <p className="text-foreground-500 text-xs mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20team%20of%20journalists%20working%20in%20dim%20lighting%2C%20multiple%20monitors%20showing%20news%20feeds%2C%20noir%20investigative%20office%20atmosphere%2C%20red%20accent%20lighting%2C%20cyberpunk%20newsroom%2C%20professional%20yet%20edgy%2C%20dark%20background%2C%20cinematic%20composition&width=800&height=600&seq=about-team-dark&orientation=landscape"
                  alt="黑料718团队"
                  title="黑料718编辑团队"
                  className="w-full h-80 object-cover object-top rounded-xl"
                />
                <div className="absolute bottom-4 right-4 bg-background-50/90 backdrop-blur-sm px-4 py-2 rounded-lg border border-background-200/60">
                  <p className="text-foreground-200 text-xs font-medium">7×24小时 · 全天候追踪</p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full bg-background-100 py-16">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
              <div className="text-center mb-12">
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-50 mb-2">
                  我们的<strong className="text-accent-400">信条</strong>
                </h2>
                <p className="text-foreground-500 text-sm">三个核心价值观，驱动我们不断前行</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {aboutInfo.values.map((value, index) => {
                  const valueImages = [
                    'https://readdy.ai/api/search-image?query=Dark%20abstract%20minimalist%20concept%20art%2C%20mysterious%20atmosphere%20with%20subtle%20red%20and%20purple%20gradient%2C%20truth%20and%20shield%20theme%2C%20dark%20background%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20editorial%20composition&width=600&height=500&seq=value-truth-01&orientation=landscape',
                    'https://readdy.ai/api/search-image?query=Dark%20abstract%20minimalist%20concept%20art%2C%20lightning%20and%20speed%20theme%2C%20mysterious%20red%20and%20purple%20gradient%2C%20dark%20background%2C%20cinematic%20noir%20style%2C%20fast%20motion%20vibe%2C%20editorial%20composition&width=600&height=500&seq=value-speed-02&orientation=landscape',
                    'https://readdy.ai/api/search-image?query=Dark%20abstract%20minimalist%20concept%20art%2C%20heart%20and%20community%20theme%2C%20mysterious%20red%20and%20purple%20gradient%2C%20dark%20background%2C%20cinematic%20noir%20style%2C%20warm%20core%2C%20editorial%20composition&width=600&height=500&seq=value-user-03&orientation=landscape',
                  ];
                  return (
                  <div
                    key={value.title}
                    className="relative h-72 rounded-xl overflow-hidden group cursor-default"
                  >
                    <img
                      src={valueImages[index]}
                      alt={value.title}
                      className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-background-900/70 group-hover:bg-background-900/50 transition-colors"></div>
                    <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                      <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center mb-4">
                        <i className={`${value.icon} text-xl text-primary-400 w-5 h-5 flex items-center justify-center`}></i>
                      </div>
                      <h3 className="text-foreground-50 text-lg font-bold mb-2">{value.title}</h3>
                      <p className="text-foreground-400 text-xs leading-relaxed max-w-xs">{value.description}</p>
                    </div>
                  </div>
                  );
                })}
              </div>
            </div>
          </section>

          <section className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-50 mb-8">
                  常见<strong className="text-primary-400">问题</strong>
                </h2>
                <div className="space-y-4">
                  {faqData.map((faq) => (
                    <details key={faq.question} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
                      <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                        <span className="text-foreground-200 text-sm font-medium pr-4">{faq.question}</span>
                        <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      </summary>
                      <div className="px-5 pb-5">
                        <p className="text-foreground-500 text-sm leading-relaxed">{faq.answer}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-50 mb-8">
                  联系<strong className="text-primary-400">我们</strong>
                </h2>
                <div className="bg-background-100 rounded-xl p-8 border border-background-200/60 space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-lg text-primary-400 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-foreground-300 text-sm font-medium mb-1">邮箱</p>
                      <p className="text-foreground-500 text-sm">{aboutInfo.contact.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-lg text-accent-400 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-foreground-300 text-sm font-medium mb-1">微信</p>
                      <p className="text-foreground-500 text-sm">{aboutInfo.contact.wechat}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-weibo-line text-lg text-secondary-400 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-foreground-300 text-sm font-medium mb-1">微博</p>
                      <p className="text-foreground-500 text-sm">{aboutInfo.contact.weibo}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-400 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-foreground-300 text-sm font-medium mb-1">地址</p>
                      <p className="text-foreground-500 text-sm">{aboutInfo.contact.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>

      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </>
  );
}